import React from "react";
import type { PathRouteProps } from "react-router-dom";
import { Route } from "react-router-dom";

const factoryRouteComponents = (routes: PathRouteProps[]): React.ReactNode => {
  const renderChildren = (childrenRoutes: PathRouteProps[]): JSX.Element[] =>
    childrenRoutes.map((route, index) => (
      <Route
        key={route?.path ?? index}
        {...route}
      >
        {route.children && renderChildren(route.children as PathRouteProps[])}
      </Route>
    ));

  return (
    <>
      {routes.map((route, index) => (
        <Route
          key={route?.path ?? index}
          index={route?.index}
          path={route.path}
          element={route.element}
          handle={route.handle}
          loader={route.loader}
          id={route.id}
          shouldRevalidate={route.shouldRevalidate}
          errorElement={route.errorElement}
        >
          {renderChildren(route.children as PathRouteProps[])}
        </Route>
      ))}
    </>
  );
};

export default factoryRouteComponents;
